<div class="content-without-stepper-and-title">
    <div class="row">
        <div class="col-4 col-pr-12 col-4 col-sm-8 col-md-12 col-lg-12 col-xl-12">
            <div class="wrap">
                <div class="image-container">
                    <img id="fourTaxWarning" alt="4x1000" src="assets/images/Amarelo@3x.png"/>
                </div>
                <div class="component-text">
                    <h1 class="title">{{ copyService.copies.four_tax_warning_title }}</h1>
                    <p class="description">
                        {{ copyService.copies.four_tax_warning_description }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
<app-controls id="fourTaxBtns" [hasPrevious]="false" [nextLabel]="copyService.copies.four_tax_warning_text_footer_button" (next)="next()"></app-controls>